import React, { Component } from "react";

import AppWrapper from "../containers/AppWrapper";
import RentableCirclesSection from "../containers/RentableCirclesSection";
class Rentals extends Component {
    render() {

        return (
            <AppWrapper>
                <section className="gray-bg">
                    <div className="main-container">
                       <RentableCirclesSection/>
                    </div>
                </section>
            </AppWrapper>
        );
    }
}

export default Rentals;
